export interface RoleObject {
  nameLabel: string; // Ditto translation string
  apiSlug: string; // A slug used in API
}

export const ADMINISTRATOR_ROLES: Readonly<RoleObject[]> = Object.freeze([
  {
    nameLabel: "super-administrator-role",
    apiSlug: "super-admin",
  },
  {
    nameLabel: "administrator",
    apiSlug: "admin",
  },
  {
    nameLabel: "read-only-role",
    apiSlug: "admin-ro",
  },
]);

export const displayRoleStringByApiSlug = (apiSlug: string): string => {
  const role = ADMINISTRATOR_ROLES.find((role) => role.apiSlug === apiSlug);
  return role?.nameLabel || "";
};
